@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.orders.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.orders.resources/"

@delegate:ResourceContentHash(1_895_241_456)
internal val Res.string.ord_add_to_cart: StringResource by lazy {
      StringResource("string:ord_add_to_cart", "ord_add_to_cart", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 39),
      ))
    }

@delegate:ResourceContentHash(685_240_709)
internal val Res.string.ord_added: StringResource by lazy {
      StringResource("string:ord_added", "ord_added", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 66, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50, 37),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.ord_back_a11y: StringResource by lazy {
      StringResource("string:ord_back_a11y", "ord_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 124, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 100, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88, 29),
      ))
    }

@delegate:ResourceContentHash(-1_555_679_390)
internal val Res.string.ord_cancel_confirm_message: StringResource by lazy {
      StringResource("string:ord_cancel_confirm_message", "ord_cancel_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 162, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118, 110),
      ))
    }

@delegate:ResourceContentHash(-1_462_209_909)
internal val Res.string.ord_cancel_failed: StringResource by lazy {
      StringResource("string:ord_cancel_failed", "ord_cancel_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 321, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229, 113),
      ))
    }

@delegate:ResourceContentHash(-2_082_627_964)
internal val Res.string.ord_cancel_keep: StringResource by lazy {
      StringResource("string:ord_cancel_keep", "ord_cancel_keep", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 479, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 379, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343, 39),
      ))
    }

@delegate:ResourceContentHash(-1_348_258_365)
internal val Res.string.ord_cancel_order: StringResource by lazy {
      StringResource("string:ord_cancel_order", "ord_cancel_order", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 543, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 427, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 383, 40),
      ))
    }

@delegate:ResourceContentHash(268_154_504)
internal val Res.string.ord_cart_empty_desc: StringResource by lazy {
      StringResource("string:ord_cart_empty_desc", "ord_cart_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 592, 195),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 480, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 424, 111),
      ))
    }

@delegate:ResourceContentHash(580_582_766)
internal val Res.string.ord_cart_empty_title: StringResource by lazy {
      StringResource("string:ord_cart_empty_title", "ord_cart_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 788, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 616, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 536, 52),
      ))
    }

@delegate:ResourceContentHash(-1_566_899_588)
internal val Res.string.ord_cart_remove_a11y: StringResource by lazy {
      StringResource("string:ord_cart_remove_a11y", "ord_cart_remove_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 857, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 673, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 589, 56),
      ))
    }

@delegate:ResourceContentHash(1_648_901_402)
internal val Res.string.ord_cart_title: StringResource by lazy {
      StringResource("string:ord_cart_title", "ord_cart_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 934, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 738, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 646, 30),
      ))
    }

@delegate:ResourceContentHash(-1_754_926_458)
internal val Res.string.ord_checkout_cta: StringResource by lazy {
      StringResource("string:ord_checkout_cta", "ord_checkout_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 977, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 769, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 677, 48),
      ))
    }

@delegate:ResourceContentHash(-1_611_786_372)
internal val Res.string.ord_checkout_failed: StringResource by lazy {
      StringResource("string:ord_checkout_failed", "ord_checkout_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1058, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 818, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 726, 79),
      ))
    }

@delegate:ResourceContentHash(1_103_113_114)
internal val Res.string.ord_checkout_note_label: StringResource by lazy {
      StringResource("string:ord_checkout_note_label", "ord_checkout_note_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1174, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 910, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 75),
      ))
    }

@delegate:ResourceContentHash(-892_300_996)
internal val Res.string.ord_checkout_pickup_note: StringResource by lazy {
      StringResource("string:ord_checkout_pickup_note", "ord_checkout_pickup_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1286, 344),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 990, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 882, 168),
      ))
    }

@delegate:ResourceContentHash(1_830_275_444)
internal val Res.string.ord_checkout_title: StringResource by lazy {
      StringResource("string:ord_checkout_title", "ord_checkout_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1631, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1211, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1051, 38),
      ))
    }

@delegate:ResourceContentHash(-992_860_219)
internal val Res.string.ord_confirm_desc: StringResource by lazy {
      StringResource("string:ord_confirm_desc", "ord_confirm_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1686, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1250, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1090, 84),
      ))
    }

@delegate:ResourceContentHash(-1_902_509_286)
internal val Res.string.ord_confirm_title: StringResource by lazy {
      StringResource("string:ord_confirm_title", "ord_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1847, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1347, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1175, 45),
      ))
    }

@delegate:ResourceContentHash(-2_026_791_634)
internal val Res.string.ord_error: StringResource by lazy {
      StringResource("string:ord_error", "ord_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1905, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1397, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1221, 45),
      ))
    }

@delegate:ResourceContentHash(1_302_457_509)
internal val Res.string.ord_history_empty_desc: StringResource by lazy {
      StringResource("string:ord_history_empty_desc", "ord_history_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1967, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1447, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1267, 78),
      ))
    }

@delegate:ResourceContentHash(1_646_840_486)
internal val Res.string.ord_history_empty_title: StringResource by lazy {
      StringResource("string:ord_history_empty_title", "ord_history_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2130, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1542, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1346, 51),
      ))
    }

@delegate:ResourceContentHash(-1_241_739_223)
internal val Res.string.ord_history_title: StringResource by lazy {
      StringResource("string:ord_history_title", "ord_history_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2210, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1594, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1398, 37),
      ))
    }

@delegate:ResourceContentHash(1_614_810_471)
internal val Res.string.ord_mo_accept: StringResource by lazy {
      StringResource("string:ord_mo_accept", "ord_mo_accept", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2268, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1640, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1436, 37),
      ))
    }

@delegate:ResourceContentHash(780_545_453)
internal val Res.string.ord_mo_cancel_message: StringResource by lazy {
      StringResource("string:ord_mo_cancel_message", "ord_mo_cancel_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2326, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1690, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1474, 93),
      ))
    }

@delegate:ResourceContentHash(813_654_382)
internal val Res.string.ord_mo_empty_desc: StringResource by lazy {
      StringResource("string:ord_mo_empty_desc", "ord_mo_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2472, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1792, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1568, 101),
      ))
    }

@delegate:ResourceContentHash(2_074_282_125)
internal val Res.string.ord_mo_empty_title: StringResource by lazy {
      StringResource("string:ord_mo_empty_title", "ord_mo_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2638, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1914, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1670, 46),
      ))
    }

@delegate:ResourceContentHash(-1_128_403_532)
internal val Res.string.ord_mo_error: StringResource by lazy {
      StringResource("string:ord_mo_error", "ord_mo_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2713, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1985, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1717, 88),
      ))
    }

@delegate:ResourceContentHash(-493_465_623)
internal val Res.string.ord_mo_failed: StringResource by lazy {
      StringResource("string:ord_mo_failed", "ord_mo_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2866, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2094, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1806, 77),
      ))
    }

@delegate:ResourceContentHash(2_017_801_710)
internal val Res.string.ord_mo_fulfill: StringResource by lazy {
      StringResource("string:ord_mo_fulfill", "ord_mo_fulfill", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3004, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2192, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1884, 50),
      ))
    }

@delegate:ResourceContentHash(73_800_178)
internal val Res.string.ord_mo_note: StringResource by lazy {
      StringResource("string:ord_mo_note", "ord_mo_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3071, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2247, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1935, 35),
      ))
    }

@delegate:ResourceContentHash(1_172_289_743)
internal val Res.string.ord_mo_paid: StringResource by lazy {
      StringResource("string:ord_mo_paid", "ord_mo_paid", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3119, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2283, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1971, 27),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.ord_mo_retry: StringResource by lazy {
      StringResource("string:ord_mo_retry", "ord_mo_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3167, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2311, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1999, 32),
      ))
    }

@delegate:ResourceContentHash(-193_062_415)
internal val Res.string.ord_mo_title: StringResource by lazy {
      StringResource("string:ord_mo_title", "ord_mo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3204, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2340, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2032, 28),
      ))
    }

@delegate:ResourceContentHash(-235_360_487)
internal val Res.string.ord_mp_add: StringResource by lazy {
      StringResource("string:ord_mp_add", "ord_mp_add", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3249, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2373, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2061, 34),
      ))
    }

@delegate:ResourceContentHash(-276_966_883)
internal val Res.string.ord_mp_available: StringResource by lazy {
      StringResource("string:ord_mp_available", "ord_mp_available", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3300, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2416, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2096, 36),
      ))
    }

@delegate:ResourceContentHash(-1_797_010_475)
internal val Res.string.ord_mp_mark_promoted: StringResource by lazy {
      StringResource("string:ord_mp_mark_promoted", "ord_mp_mark_promoted", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3341, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2457, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2133, 52),
      ))
    }

@delegate:ResourceContentHash(1_810_325_188)
internal val Res.string.ord_mp_name_en: StringResource by lazy {
      StringResource("string:ord_mp_name_en", "ord_mp_name_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3418, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2518, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2186, 54),
      ))
    }

@delegate:ResourceContentHash(-553_847_939)
internal val Res.string.ord_mp_name_fa: StringResource by lazy {
      StringResource("string:ord_mp_name_fa", "ord_mp_name_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3489, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2573, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2241, 58),
      ))
    }

@delegate:ResourceContentHash(-1_300_603_701)
internal val Res.string.ord_mp_price: StringResource by lazy {
      StringResource("string:ord_mp_price", "ord_mp_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3552, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2632, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2300, 36),
      ))
    }

@delegate:ResourceContentHash(-734_347_473)
internal val Res.string.ord_mp_promoted: StringResource by lazy {
      StringResource("string:ord_mp_promoted", "ord_mp_promoted", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3868, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2848, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2504, 35),
      ))
    }

@delegate:ResourceContentHash(-433_585_208)
internal val Res.string.ord_mp_promoted_desc: StringResource by lazy {
      StringResource("string:ord_mp_promoted_desc", "ord_mp_promoted_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3617, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2669, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2337, 112),
      ))
    }

@delegate:ResourceContentHash(603_920_589)
internal val Res.string.ord_mp_promoted_title: StringResource by lazy {
      StringResource("string:ord_mp_promoted_title", "ord_mp_promoted_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3782, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2778, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2450, 53),
      ))
    }

@delegate:ResourceContentHash(1_333_398_462)
internal val Res.string.ord_mp_remove_promotion: StringResource by lazy {
      StringResource("string:ord_mp_remove_promotion", "ord_mp_remove_promotion", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3924, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2884, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2540, 55),
      ))
    }

@delegate:ResourceContentHash(2_020_592_261)
internal val Res.string.ord_mp_title: StringResource by lazy {
      StringResource("string:ord_mp_title", "ord_mp_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3996, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2944, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2596, 32),
      ))
    }

@delegate:ResourceContentHash(-906_002_981)
internal val Res.string.ord_pay_at_pickup: StringResource by lazy {
      StringResource("string:ord_pay_at_pickup", "ord_pay_at_pickup", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4037, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2977, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2629, 81),
      ))
    }

@delegate:ResourceContentHash(36_254_938)
internal val Res.string.ord_proceed_checkout: StringResource by lazy {
      StringResource("string:ord_proceed_checkout", "ord_proceed_checkout", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4199, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3071, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2711, 56),
      ))
    }

@delegate:ResourceContentHash(-1_805_875_339)
internal val Res.string.ord_product_image_a11y: StringResource by lazy {
      StringResource("string:ord_product_image_a11y", "ord_product_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4268, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3128, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2768, 62),
      ))
    }

@delegate:ResourceContentHash(1_852_260_214)
internal val Res.string.ord_products_section_title: StringResource by lazy {
      StringResource("string:ord_products_section_title", "ord_products_section_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4347, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3207, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2831, 62),
      ))
    }

@delegate:ResourceContentHash(-1_538_251_307)
internal val Res.string.ord_promotions_section_title: StringResource by lazy {
      StringResource("string:ord_promotions_section_title", "ord_promotions_section_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4426, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3270, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2894, 52),
      ))
    }

@delegate:ResourceContentHash(-590_436_062)
internal val Res.string.ord_prop_address: StringResource by lazy {
      StringResource("string:ord_prop_address", "ord_prop_address", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4487, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3323, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2947, 44),
      ))
    }

@delegate:ResourceContentHash(1_622_792_355)
internal val Res.string.ord_prop_area: StringResource by lazy {
      StringResource("string:ord_prop_area", "ord_prop_area", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4548, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3372, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2992, 37),
      ))
    }

@delegate:ResourceContentHash(42_003_569)
internal val Res.string.ord_prop_bathrooms: StringResource by lazy {
      StringResource("string:ord_prop_bathrooms", "ord_prop_bathrooms", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4610, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3418, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3030, 38),
      ))
    }

@delegate:ResourceContentHash(1_910_973_538)
internal val Res.string.ord_prop_baths_short: StringResource by lazy {
      StringResource("string:ord_prop_baths_short", "ord_prop_baths_short", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4665, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3465, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3069, 40),
      ))
    }

@delegate:ResourceContentHash(-875_182_466)
internal val Res.string.ord_prop_bedrooms: StringResource by lazy {
      StringResource("string:ord_prop_bedrooms", "ord_prop_bedrooms", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4714, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3506, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3110, 37),
      ))
    }

@delegate:ResourceContentHash(-69_094_069)
internal val Res.string.ord_prop_beds_short: StringResource by lazy {
      StringResource("string:ord_prop_beds_short", "ord_prop_beds_short", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4780, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3544, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3148, 39),
      ))
    }

@delegate:ResourceContentHash(-1_059_116_420)
internal val Res.string.ord_prop_sqft_short: StringResource by lazy {
      StringResource("string:ord_prop_sqft_short", "ord_prop_sqft_short", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4828, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3584, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3188, 43),
      ))
    }

@delegate:ResourceContentHash(57_170_581)
internal val Res.string.ord_prop_toggle_desc: StringResource by lazy {
      StringResource("string:ord_prop_toggle_desc", "ord_prop_toggle_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4884, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3624, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3232, 108),
      ))
    }

@delegate:ResourceContentHash(-1_724_835_177)
internal val Res.string.ord_prop_toggle_title: StringResource by lazy {
      StringResource("string:ord_prop_toggle_title", "ord_prop_toggle_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5045, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3761, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3341, 53),
      ))
    }

@delegate:ResourceContentHash(-4_894_443)
internal val Res.string.ord_qty_line: StringResource by lazy {
      StringResource("string:ord_qty_line", "ord_qty_line", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5095, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3819, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3395, 36),
      ))
    }

@delegate:ResourceContentHash(-1_396_204_518)
internal val Res.string.ord_replace_cart_cancel: StringResource by lazy {
      StringResource("string:ord_replace_cart_cancel", "ord_replace_cart_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5132, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3856, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3432, 47),
      ))
    }

@delegate:ResourceContentHash(-1_932_594_548)
internal val Res.string.ord_replace_cart_confirm: StringResource by lazy {
      StringResource("string:ord_replace_cart_confirm", "ord_replace_cart_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5204, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3912, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3480, 44),
      ))
    }

@delegate:ResourceContentHash(739_518_369)
internal val Res.string.ord_replace_cart_title: StringResource by lazy {
      StringResource("string:ord_replace_cart_title", "ord_replace_cart_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5261, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3957, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3525, 50),
      ))
    }

@delegate:ResourceContentHash(1_893_806_802)
internal val Res.string.ord_replace_cart_warning: StringResource by lazy {
      StringResource("string:ord_replace_cart_warning", "ord_replace_cart_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5332, 220),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4016, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3576, 124),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.ord_retry: StringResource by lazy {
      StringResource("string:ord_retry", "ord_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5553, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4169, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3701, 29),
      ))
    }

@delegate:ResourceContentHash(1_235_080_055)
internal val Res.string.ord_status_cancelled: StringResource by lazy {
      StringResource("string:ord_status_cancelled", "ord_status_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5587, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4195, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3731, 40),
      ))
    }

@delegate:ResourceContentHash(2_043_399_029)
internal val Res.string.ord_status_confirmed: StringResource by lazy {
      StringResource("string:ord_status_confirmed", "ord_status_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5632, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4236, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3772, 40),
      ))
    }

@delegate:ResourceContentHash(1_798_796_355)
internal val Res.string.ord_status_fulfilled: StringResource by lazy {
      StringResource("string:ord_status_fulfilled", "ord_status_fulfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5685, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4281, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3813, 36),
      ))
    }

@delegate:ResourceContentHash(1_396_517_131)
internal val Res.string.ord_status_pending: StringResource by lazy {
      StringResource("string:ord_status_pending", "ord_status_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5730, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4318, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3850, 38),
      ))
    }

@delegate:ResourceContentHash(360_039_416)
internal val Res.string.ord_subtotal: StringResource by lazy {
      StringResource("string:ord_subtotal", "ord_subtotal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5781, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4361, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3889, 32),
      ))
    }

@delegate:ResourceContentHash(812_158_875)
internal val Res.string.ord_time_days_ago: StringResource by lazy {
      StringResource("string:ord_time_days_ago", "ord_time_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5822, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4398, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3922, 41),
      ))
    }

@delegate:ResourceContentHash(2_094_969_652)
internal val Res.string.ord_time_hours_ago: StringResource by lazy {
      StringResource("string:ord_time_hours_ago", "ord_time_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5872, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4444, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3964, 42),
      ))
    }

@delegate:ResourceContentHash(-2_012_089_126)
internal val Res.string.ord_time_just_now: StringResource by lazy {
      StringResource("string:ord_time_just_now", "ord_time_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5927, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4491, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4007, 37),
      ))
    }

@delegate:ResourceContentHash(-1_591_511_977)
internal val Res.string.ord_time_minutes_ago: StringResource by lazy {
      StringResource("string:ord_time_minutes_ago", "ord_time_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5977, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4537, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4045, 44),
      ))
    }

@delegate:ResourceContentHash(-1_205_191_231)
internal val Res.string.ord_time_weeks_ago: StringResource by lazy {
      StringResource("string:ord_time_weeks_ago", "ord_time_weeks_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6038, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4586, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4090, 42),
      ))
    }

@delegate:ResourceContentHash(-1_575_913_996)
internal val Res.string.ord_view_orders: StringResource by lazy {
      StringResource("string:ord_view_orders", "ord_view_orders", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6093, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4637, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4133, 43),
      ))
    }

@delegate:ResourceContentHash(-1_370_303_378)
internal val Res.string.orders_product_save_failed: StringResource by lazy {
      StringResource("string:orders_product_save_failed", "orders_product_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6169, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4685, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4177, 90),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ord_add_to_cart", Res.string.ord_add_to_cart)
  map.put("ord_added", Res.string.ord_added)
  map.put("ord_back_a11y", Res.string.ord_back_a11y)
  map.put("ord_cancel_confirm_message", Res.string.ord_cancel_confirm_message)
  map.put("ord_cancel_failed", Res.string.ord_cancel_failed)
  map.put("ord_cancel_keep", Res.string.ord_cancel_keep)
  map.put("ord_cancel_order", Res.string.ord_cancel_order)
  map.put("ord_cart_empty_desc", Res.string.ord_cart_empty_desc)
  map.put("ord_cart_empty_title", Res.string.ord_cart_empty_title)
  map.put("ord_cart_remove_a11y", Res.string.ord_cart_remove_a11y)
  map.put("ord_cart_title", Res.string.ord_cart_title)
  map.put("ord_checkout_cta", Res.string.ord_checkout_cta)
  map.put("ord_checkout_failed", Res.string.ord_checkout_failed)
  map.put("ord_checkout_note_label", Res.string.ord_checkout_note_label)
  map.put("ord_checkout_pickup_note", Res.string.ord_checkout_pickup_note)
  map.put("ord_checkout_title", Res.string.ord_checkout_title)
  map.put("ord_confirm_desc", Res.string.ord_confirm_desc)
  map.put("ord_confirm_title", Res.string.ord_confirm_title)
  map.put("ord_error", Res.string.ord_error)
  map.put("ord_history_empty_desc", Res.string.ord_history_empty_desc)
  map.put("ord_history_empty_title", Res.string.ord_history_empty_title)
  map.put("ord_history_title", Res.string.ord_history_title)
  map.put("ord_mo_accept", Res.string.ord_mo_accept)
  map.put("ord_mo_cancel_message", Res.string.ord_mo_cancel_message)
  map.put("ord_mo_empty_desc", Res.string.ord_mo_empty_desc)
  map.put("ord_mo_empty_title", Res.string.ord_mo_empty_title)
  map.put("ord_mo_error", Res.string.ord_mo_error)
  map.put("ord_mo_failed", Res.string.ord_mo_failed)
  map.put("ord_mo_fulfill", Res.string.ord_mo_fulfill)
  map.put("ord_mo_note", Res.string.ord_mo_note)
  map.put("ord_mo_paid", Res.string.ord_mo_paid)
  map.put("ord_mo_retry", Res.string.ord_mo_retry)
  map.put("ord_mo_title", Res.string.ord_mo_title)
  map.put("ord_mp_add", Res.string.ord_mp_add)
  map.put("ord_mp_available", Res.string.ord_mp_available)
  map.put("ord_mp_mark_promoted", Res.string.ord_mp_mark_promoted)
  map.put("ord_mp_name_en", Res.string.ord_mp_name_en)
  map.put("ord_mp_name_fa", Res.string.ord_mp_name_fa)
  map.put("ord_mp_price", Res.string.ord_mp_price)
  map.put("ord_mp_promoted", Res.string.ord_mp_promoted)
  map.put("ord_mp_promoted_desc", Res.string.ord_mp_promoted_desc)
  map.put("ord_mp_promoted_title", Res.string.ord_mp_promoted_title)
  map.put("ord_mp_remove_promotion", Res.string.ord_mp_remove_promotion)
  map.put("ord_mp_title", Res.string.ord_mp_title)
  map.put("ord_pay_at_pickup", Res.string.ord_pay_at_pickup)
  map.put("ord_proceed_checkout", Res.string.ord_proceed_checkout)
  map.put("ord_product_image_a11y", Res.string.ord_product_image_a11y)
  map.put("ord_products_section_title", Res.string.ord_products_section_title)
  map.put("ord_promotions_section_title", Res.string.ord_promotions_section_title)
  map.put("ord_prop_address", Res.string.ord_prop_address)
  map.put("ord_prop_area", Res.string.ord_prop_area)
  map.put("ord_prop_bathrooms", Res.string.ord_prop_bathrooms)
  map.put("ord_prop_baths_short", Res.string.ord_prop_baths_short)
  map.put("ord_prop_bedrooms", Res.string.ord_prop_bedrooms)
  map.put("ord_prop_beds_short", Res.string.ord_prop_beds_short)
  map.put("ord_prop_sqft_short", Res.string.ord_prop_sqft_short)
  map.put("ord_prop_toggle_desc", Res.string.ord_prop_toggle_desc)
  map.put("ord_prop_toggle_title", Res.string.ord_prop_toggle_title)
  map.put("ord_qty_line", Res.string.ord_qty_line)
  map.put("ord_replace_cart_cancel", Res.string.ord_replace_cart_cancel)
  map.put("ord_replace_cart_confirm", Res.string.ord_replace_cart_confirm)
  map.put("ord_replace_cart_title", Res.string.ord_replace_cart_title)
  map.put("ord_replace_cart_warning", Res.string.ord_replace_cart_warning)
  map.put("ord_retry", Res.string.ord_retry)
  map.put("ord_status_cancelled", Res.string.ord_status_cancelled)
  map.put("ord_status_confirmed", Res.string.ord_status_confirmed)
  map.put("ord_status_fulfilled", Res.string.ord_status_fulfilled)
  map.put("ord_status_pending", Res.string.ord_status_pending)
  map.put("ord_subtotal", Res.string.ord_subtotal)
  map.put("ord_time_days_ago", Res.string.ord_time_days_ago)
  map.put("ord_time_hours_ago", Res.string.ord_time_hours_ago)
  map.put("ord_time_just_now", Res.string.ord_time_just_now)
  map.put("ord_time_minutes_ago", Res.string.ord_time_minutes_ago)
  map.put("ord_time_weeks_ago", Res.string.ord_time_weeks_ago)
  map.put("ord_view_orders", Res.string.ord_view_orders)
  map.put("orders_product_save_failed", Res.string.orders_product_save_failed)
}
